export default __webpack_public_path__ + "media/images/favicon/android-chrome-72x72-6d394f1646f04da983119e1e49001dd3.png";